/**
 * PxField — a number input with a trailing "px" unit, for the editor's size
 * controls (font size, border radius, legend/marker/icon size, …). Keeps the
 * panel's 150px control width + h-9 so it lines up with the other fields; the
 * "px" sits inside on the right and is non-interactive.
 */

import { Input } from "@provenleap/ui";

export interface PxFieldProps {
  value: number | "";
  onChange: (value: number | undefined) => void;
  min?: number;
  max?: number;
  placeholder?: string;
  ariaLabel: string;
  testId?: string;
}

export function PxField({ value, onChange, min, max, placeholder, ariaLabel, testId }: PxFieldProps) {
  return (
    <div className="relative w-full">
      <Input
        type="number"
        min={min}
        max={max}
        aria-label={ariaLabel}
        data-testid={testId}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value === "" ? undefined : Number(e.target.value))}
        className="h-9 w-full rounded-lg pr-8 text-[13.5px]"
      />
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[12px] text-muted-foreground">
        px
      </span>
    </div>
  );
}
